import { useEffect, useState } from 'react'

import { Constants } from '@app/config/constants/Constants'
import { LogUtils } from '@app/utils/LogUtils'

import { MaintenanceStatus } from '../model/enums'

export const useCheckMaintenance = () => {
  const [isMaintenance, setIsMaintenance] = useState<boolean | null>(null)
  const [lastMaintenanceTimestamp, setLastMaintenanceTimestamp] = useState<number>(
    Date.now() - Constants.MAINTENANCE_CHECK_INTERVAL
  )

  useEffect(() => {
    const shouldCheckMaintenance = Date.now() - lastMaintenanceTimestamp >= Constants.MAINTENANCE_CHECK_INTERVAL

    if (isMaintenance || shouldCheckMaintenance) {
      checkMaintenanceStatus()
    }
  }, [])

  const checkMaintenanceStatus = async () => {
    setLastMaintenanceTimestamp(Date.now())

    try {
      const result = await fetch(Constants.MAINTENANCE_URL)
      const isCIRun = navigator.userAgent.includes('Playwright')

      const { status }: { status: MaintenanceStatus } = await result.json()
      if (status === MaintenanceStatus.MAINTENANCE && !isCIRun) {
        setIsMaintenance(true)
      } else if (status === MaintenanceStatus.UP || isCIRun) {
        setIsMaintenance(false)
      }
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') {
        console.info('Fetch request timed out')
      } else {
        LogUtils.logError(error, 'MainLayout', 'checkMaintenanceStatus', undefined, false)

        setIsMaintenance(true)
      }
    }
  }

  return { isMaintenance, checkMaintenanceStatus }
}
